import { haversine } from './model';

const MAX_WP = 9;
const ll = (p) => `${p.lat.toFixed(6)},${p.lon.toFixed(6)}`;

export const routeLink = (p) => `https://www.google.com/maps/dir/?api=1&destination=${ll(p)}&travelmode=driving`;

export function currentPosition(fallback) {
  return new Promise((res) => {
    if (!navigator.geolocation) return res({ ...fallback, gps: false });
    navigator.geolocation.getCurrentPosition(
      (pos) => res({ lat: pos.coords.latitude, lon: pos.coords.longitude, gps: true }),
      () => res({ ...fallback, gps: false }),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 },
    );
  });
}

// nearest-neighbour order from start; returns stops with leg distance in m
export function orderStops(start, reports) {
  const left = [...reports];
  const out = [];
  let cur = start;
  while (left.length) {
    let bi = 0; let bd = Infinity;
    left.forEach((r, i) => { const d = haversine([cur.lat, cur.lon], [r.lat, r.lon]); if (d < bd) { bd = d; bi = i; } });
    const [r] = left.splice(bi, 1);
    out.push({ ...r, dist: bd });
    cur = r;
  }
  return out;
}

// Google Maps allows 9 waypoints + destination per link
export function routeLegs(start, stops) {
  const legs = [];
  let origin = start;
  for (let i = 0; i < stops.length; i += MAX_WP + 1) {
    const chunk = stops.slice(i, i + MAX_WP + 1);
    const dest = chunk[chunk.length - 1];
    const wps = chunk.slice(0, -1).map(ll).join('|');
    legs.push({ stops: chunk, url: `https://www.google.com/maps/dir/?api=1${origin ? `&origin=${ll(origin)}` : ''}&destination=${ll(dest)}${wps ? `&waypoints=${encodeURIComponent(wps)}` : ''}&travelmode=driving` });
    origin = dest;
  }
  return legs;
}
